"use client"

import { createContext, useContext, useState } from "react"
import { Snackbar, Alert } from "@mui/material"

const NotificationContext = createContext()

export const useNotification = () => useContext(NotificationContext)

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "info", // 'error', 'warning', 'info', 'success'
  })

  const showNotification = (message, severity = "info") => {
    setNotification({
      open: true,
      message,
      severity,
    })
  }

  const hideNotification = () => {
    setNotification({
      ...notification,
      open: false,
    })
  }

  const value = {
    showNotification,
    hideNotification,
  }

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={hideNotification}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={hideNotification} severity={notification.severity} sx={{ width: "100%" }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  )
}

